import axios from "../utils/axios-interceptor.js";
import auditData from "../mock-data/audit.json";

export const getCodeAuditApi = async(payload) => {
  try {
    if(window.isMockData){
      const data = auditData;

      // Simulate a 5-second delay
      return await new Promise((resolve) => {
        setTimeout(() => {
          resolve(data);
        }, 5000);
      });
    } else {
      const { repoURL, guidelineContent, selected_model } = payload;

      if (!repoURL || !guidelineContent) {
        throw new Error("Repository URL and guideline content are required");
      }

      const encodedRepoURL = encodeURIComponent(repoURL);
      const form = new FormData();
 
      form.append("guidelineContent", guidelineContent)
      form.append("selected_model", selected_model)

      const res = await axios.post(`/code_audit/?repoURL=${encodedRepoURL}`, form, {
        headers: {
          "Content-Type": "multipart/form-data"
        },
        validateStatus: function (status) {
          return status >= 200 && status < 500; // Handle only client errors manually
        }
      });

      if (!res || !res.data) {
        throw new Error("Invalid response received from server");
      }
      
      const data = await res.data;
      return data;
    }
    
  } catch (error) {
    console.error("API Error:", error.response ? error.response.data : error.message);
    console.error("Full error object:", error);
    throw error;
  }
};

export const getCodeStandardApi = async(payload) => {
  try {
    const res = await axios.get(`/code-standard/${payload}`)
    const data = await res.data
    return data
  } catch (error) {
    throw new Error(error.message)
  }
}

export const getUploadStandardApi = async(payload) => {
  try {
    const res = await axios.post("/upload-standard/", payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      }
    });
    const data = await res.data;
    return data;
  } catch (error) {
    throw new Error(error.message)
  }
}